import env from './env';

export const STATIC_PATH = env.STATIC_PATH || '/';
